import { render, staticRenderFns } from "./MemberFaceApprovePage.vue?vue&type=template&id=28a0304c&scoped=true"
import script from "./MemberFaceApprovePage.vue?vue&type=script&lang=js"
export * from "./MemberFaceApprovePage.vue?vue&type=script&lang=js"
import style0 from "./MemberFaceApprovePage.vue?vue&type=style&index=0&id=28a0304c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0304c",
  null
  
)

export default component.exports